import { useEffect } from "react";
import { getTile } from "../slices/tile";
import Tile from "../types/tile";

export const useDataLoader = ({
  tile,
  dispatch,
  detail,
  setTileModel,
  globalReload,
}: {
  tile: Tile;
  dispatch: any;
  detail?: boolean;
  setTileModel: React.Dispatch<React.SetStateAction<Tile>>;
  globalReload: {
    isLoading: boolean;
    loadingTiles: number[];
  };
}) => {
  // Load data and set loading states
  useEffect(() => {
    const getTileData = async () => {
      if (!tile?.id) return;

      if (!!detail) {
        setTileModel(tile);
        return;
      }

      const tileData = await dispatch(
        getTile({ id: tile?.id!, includeData: true, fullTile: false })
      );

      if (tileData?.payload) {
        setTileModel(tileData.payload!);
      }
    };

    if (
      !!detail ||
      (globalReload.isLoading &&
        globalReload.loadingTiles.find((x: any) => x === tile.id))
    ) {
      getTileData();
    }
  }, [dispatch, detail, tile, globalReload, setTileModel]);
};
